module.exports = "<!-- <div class=\"sidebar-header\"></div> -->"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/app-sidebar-header/app-sidebar-header.component.html
// module id = ../../../../../src/app/components/app-sidebar-header/app-sidebar-header.component.html
// module chunks = main